/** "January 9, 1999", from "1999-01-09" (a calendar date, no time zone to shift it). */
export const releaseDate = (date) => new Date(`${date}T12:00:00`).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
